<script lang="ts">
  import FoojiLogo from "../assets/fooji-logo.svg";
  import Button from "./Button.svelte";
  import Close from "./Icons/Close.svelte";
  import Hamburger from "./Icons/Hamburger.svelte";
  import Mail from "./Icons/Mail.svelte";
  import { sessionStore } from "../lib/stores/session";
  import { errorRoutePaths } from "../lib/routing";
  import { getCopy } from "../lib/stores/copy";
  import MobileMenu from "./MobileMenu.svelte";
  import I18NDropdown from "./I18n/Dropdown.svelte";
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";
  import { getPageTitle, getStepNumberAndTotal } from "../lib/stores/pageProgress";

  let isOpen = false;

  const toggleMenu = () => (isOpen = !isOpen);

  $: isHome = $sessionStore.currentPath === "/";
  $: isErrorPage = errorRoutePaths.includes($sessionStore.currentPath);
  $: copy = $getCopy("layout") as Record<string, string>;
  $: languages = $getCopy("languages", { basePath: "", defaultReturnValue: ["en"] }) as string[];
  $: pageTitle = $getPageTitle;
  $: progress = $getStepNumberAndTotal;
  $: showPageTitle = pageTitle && pageTitle.length && !isOpen;
</script>

<header
  class="fixed top-0 left-0 w-full flex p-4 lg:px-14 justify-center items-center lg:justify-between z-10"
  class:outline-border={!(isHome || isErrorPage)}>
  {#if showPageTitle}
    <div class="lg:hidden">
      <Typography mobile={TypographyType.Headline3Medium} desktop={TypographyType.Headline3}>
        {#if progress}{progress.stepNumber}/{progress.totalSteps}{/if} {pageTitle}
      </Typography>
    </div>
  {/if}
  <img class:hidden={isErrorPage || showPageTitle} class="lg:block" src={FoojiLogo} alt="Fooji Logo" />

  <div class="flex flex-row gap-6">
    {#if languages.length > 1}
      <I18NDropdown />
    {/if}
    <Button secondary isLink href="mailto:help@fooji.com" class="hidden lg:flex">
      <Mail slot="icon"></Mail>{copy.contactSupportCopy}
    </Button>
  </div>
  <button
    class="flex absolute justify-center items-center absolute lg:hidden right-4 w-6 h-6"
    on:click={toggleMenu}
    aria-label="menu">
    {#if isOpen}
      <Close />
    {:else}
      <Hamburger />
    {/if}
  </button>
</header>
{#if isOpen}
  <MobileMenu />
{/if}

<style>
  header {
    height: 3rem;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    background: var(--header-background);
    border-bottom-color: var(--header-background);
  }

  /* FIXME: maybe we should just have the correct padding on the svg directly? */
  img {
    width: 5.375rem;
    padding: 0.478125rem 0.4575rem 0.23375rem 0.4575rem;
  }

  @media screen and (min-width: 1024px) {
    header {
      height: 4.6875rem;
    }

    img {
      width: 6.25rem;
      padding: 0.875rem 0.125rem 0.603125rem 0.25rem;
    }

    header.outline-border {
      border-bottom-color: var(--header-border-color);
    }
  }
</style>
